<template>
  <modal
    name="confirmDeleteDialog"
    :clickToClose="false"
    :delay="100"
    :width="450"
    classes="modalBoon"
    transition="nice-modal-fade"
  >
    <h2>{{ $t('Delete Company?') }}</h2>

    <p>
      {{ $t('Are you sure you want to delete the company {name}?', { name: company.companyName || '??' }) }}
    </p>

    <div v-if="companyPersons">
      <p>
        {{
          $t(
            'There is one person in this company ::: There are {people} persons in this company',
            { people: peopleCount },
            peopleCount
          )
        }}
      </p>

      <div class="d-flex flex-column">
        <span v-for="person in companyPersonsSample" :key="person._id">
          {{ person.firstName }} {{ person.lastName }}
        </span>
      </div>
    </div>

    <p>{{ $t('This action cannot be undone!') }}</p>

    <ul class="modalButtons">
      <li>
        <button class="darkButton" @click="confirmedDeleteCompany()">{{ $t('Delete Company') }}</button>
      </li>
      <li>
        <button class="lightButton" @click="$modal.hide('confirmDeleteDialog')">{{ $t("Don't Delete") }}</button>
      </li>
    </ul>
  </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ConfirmDeleteDialog',

  props: {
    company: Object,
  },

  computed: {
    ...mapGetters(['persons']),

    companyPersons() {
      return this.company._id ? this.persons({ companyId: this.company._id })[this.company._id] : [];
    },

    companyPersonsSample() {
      return this.companyPersons.slice(0, 5);
    },

    peopleCount() {
      return Object.entries(this.companyPersons).length;
    },
  },

  methods: {
    ...mapActions(['deleteCompany']),

    confirmedDeleteCompany() {
      this.deleteCompany({ company: this.company });
      this.$router.push({ name: 'OrganisationOverview' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/organisation/EditCompany/ConfirmDeleteDialog/index.vue